import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      {/* Quick Links */}
      <div className="footer-section footer-links">
        <h3>Quick Links</h3>
        <ul>
          <li><Link to="/" className="footer-link">Home</Link></li>
          <li><Link to="/about" className="footer-link">About</Link></li>
          <li><Link to="/products" className="footer-link">Products</Link></li>
          <li><Link to="/contact" className="footer-link">Contact</Link></li>
        </ul>
      </div>

      {/* Contact Info */}
      <div className="footer-section footer-contact">
        <h3>Contact</h3>
        <p>Email: <a href="mailto:info@saisenaimpex.com" className="footer-link">info@saisenaimpex.com</a></p>
        <p>Phone: <a href="tel:+91 421 4058 262" className="footer-link">+91 421 4058 262</a></p>
        <p>44A, Kumaran Colony Extn.<br />Rakkiyapalam Road, Ammapalayam, Tirupur</p>
      </div>

      {/* Map */}
      <div className="footer-section footer-map">
        <h3>Location</h3>
        <div className="map-embed">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d760.1703705218405!2d77.30369975785695!3d11.155213267963559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9073f6e52462f%3A0xa3b6353937604dc7!2sSai%20Sena%20Impex!5e0!3m2!1sen!2sin!4v1755860870194!5m2!1sen!2sin"
            width="100%"
            height="140"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
